module.exports = __webpack_public_path__ + "img/Gruppenführer_B_1.c9223bfc.svg";